import styled from 'styled-components';

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
  font-family: Nunito Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 0;
`;
